<iframe id="social_iframe" [src]="ssoUrl"></iframe>
